module.exports = __webpack_public_path__ + "images/emoji/eight_spoked_asterisk.06b376e47698b6d6032d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/eight_spoked_asterisk.png
// module id = WSzT
// module chunks = 1